import { AdminFormComponent } from "Components/Shared";

const EditAdmin = () => {
  return <AdminFormComponent isEditAdmin={true} />;
};

export default EditAdmin;
